export default __webpack_public_path__ + "static/media/complementary--tow-away-zone--g3.22f7f3eb.png";